// Check for max character limit
export const maxCharLimitCheck = (
  value: string,
  maxChar: number,
  errorMsg: string,
): any => {
  if (value.length > maxChar) return errorMsg;
  return null;
};
